import PropTypes from 'prop-types';
import React from 'react';

export const LimitOrderWrapper = ({ Component }) => {
  const details = {
    tacticName: 'LIMIT_ORDER',
    category: 'Entry',
    type: 'Limit Order',
    domain: 'Underlying',
  };
  return <Component details={details} />;
};

LimitOrderWrapper.propTypes = {
  Component: PropTypes.any,
  softOrder: PropTypes.any
};


